<template>
  <el-dialog
      v-dialogDrag
      title="所属用户"
      :visible="visible"
      width="60%"
      @open="qryInfo"
      @close="close"
      :close-on-click-modal="false"
  >

    <div class="query_box">
      <el-form :model="form" ref="form" label-position="100px" size="medium">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input
                v-model="form.name"
                size="medium"
                placeholder="用户名查询"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-button
                size="medium"
                type="primary"
                icon="el-icon-search"
                @click="qryInfo()"
            >查询
            </el-button
            >
            <el-button size="medium" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table_box">
      <data-table :columns="tableColumns" :data="memberTableData" @selects="selects">
      </data-table>
      <Pagination :page.sync="page"/>
    </div>

  </el-dialog>
</template>

<script>
import index from "@/components/mixins/index";
import dialog from '@/components/mixins/dialog'
import DataTable from "@/components/common/DataTable.vue";
import {getFunctionRole} from "./api/index"

export default {
  mixins: [dialog, index],
  props: {
    memberForm: {type: Object | null, required: true, default: null},
  },
  data() {
    return {
      memberTableData: [],
      form: {},
      tableColumns: [
        {label: "角色名", prop: "name", minWidth: "60", sort: true},
        {label: "备注", prop: "remark", minWidth: "60"},
      ],
      options: [],
      value: '',
    };
  },
  methods: {
    qryInfo() {
      let data = {};
      let id = this.memberForm.id;
      data.roleName = this.form.name;
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      getFunctionRole(id, data)
          .then((res) => {
            this.memberTableData = res.data.data.records;
            this.page.total = res.data.data.total;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });
    },
  },
  components: {
    DataTable
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.text-right {
  text-align: right;
}

.table_box {
  margin-top: 20px;
}

.query_box ::v-deep .el-input__inner {
  height: 37px;
}

</style>


